import { render, staticRenderFns } from "./DettaglioPartecipa.vue?vue&type=template&id=4cd07a48&"
import script from "./DettaglioPartecipa.vue?vue&type=script&lang=js&"
export * from "./DettaglioPartecipa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports